/**
 * angularjs扩展插件
 * 2018-3-12
 * Bai.Zhiming
 */
"use strict";
angular.module("angularPlusModule", []).
config([function() {
    /**
     * [invalidPosition description] 错误表单项定位方法
     * @return {[type]} [description]
     */
    angular.invalidPosition = function(form, $element) {
        var index = 0;
        for (var j in form.$error) {
            var item = $element.find("[name='" + j + "']")[0];
            var itemScope = $(item).prev().data().$scope;
            if ($(item).attr("is-show-tips")) {
                itemScope.isShowTips = true;
            }
            if (index === 0) {
                item.focus();
                item.blur();
                index++;
            }
        }
    };
}]);